import React, { useEffect, useState } from 'react'
import { FormCustom, Input, SwitchToggle } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'
import { apiResource, doToast } from '../../../utils'
import { doRequestGet } from '../../../api'
import SelectCustom from '../../../components/select-custom/SelectCustom'
import { toast } from 'react-toastify'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EventForm = ({ rowId, setReload }) => {
  const [row, setRow] = useState({
    p_id_event: '',
    p_name_event: '',
    p_date_event: '',
    p_hour_event: '',
    p_location_event: '',
    p_image_event: [],
    p_image_event_path: '',
    p_banner_small_event: [],
    p_banner_small_event_path: '',
    p_banner_large_event: [],
    p_banner_large_event_path: '',
    p_slug_event: '',
    p_id_type_event: '',
    p_enabled_event: 0,
    p_pdf_background: [],
    p_pdf_background_path: '',
    p_show_ecommerce: 0,
  })
  const [ready, setReady] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewBannerSmall, setPreviewBannerSmall] = useState(null)
  const [previewBannerLarge, setPreviewBannerLarge] = useState(null)
  const [previewBg, setPreviewBg] = useState(null)
  const [typeEvents, setTypeEvents] = useState([])

  const [content, setContent] = useState('')

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ]
  }

  const dataSubmit = useMemo(() => {
    let formData = new FormData();

    for (const key in row) {
      if (key === 'p_image_event' || key === 'p_banner_small_event' || key === 'p_banner_large_event' || key === 'p_pdf_background') {
        if (row[key].length > 0) {
          formData.append(key, row[key][0]);
        }
      } else {
        formData.append(key, row[key]);
      }
    }

    formData.append('p_description_event', content);

    return formData;
  }, [row, content])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/event',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/event/' + rowId,
    rowId: rowId
  })

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          const getTypesEvents = await doRequestGet({
            url: '/type-event'
          })
          setTypeEvents(getTypesEvents.data);

          if (rowId) {
            setRow({
              p_id_event: getRow.id_event,
              p_name_event: getRow.name_event,
              p_date_event: getRow.date_event,
              p_hour_event: getRow.hour_event,
              p_location_event: getRow.location_event,
              p_image_event: [],
              p_image_event_path: getRow.image_event,
              p_banner_small_event: [],
              p_banner_small_event_path: getRow.banner_small_event,
              p_banner_large_event: [],
              p_banner_large_event_path: getRow.banner_large_event,
              p_id_type_event: getRow.id_type_event,
              p_slug_event: getRow.slug_event,
              p_enabled_event: getRow.enabled_event,
              p_pdf_background: [],
              p_pdf_background_path: getRow.pdf_background,
              p_show_ecommerce: getRow.show_ecommerce,
            })

            setContent(getRow.description_event)
          }
          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready, content])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      if (!row.p_id_type_event) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar un tipo de evento',
          toast
        })
        return
      }

      // validate if the slug onle has letters and numbers and -
      if (!/^[a-zA-Z0-9-]*$/.test(row.p_slug_event)) {
        doToast({
          response: 'warning',
          message: 'El slug solo debe contener letras, números y guiones medios',
          toast
        })
        return
      }

      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <Input
        text="Nombre"
        placeholder="Nombre"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_name_event}
        onChange={e => {
          setRow({
            ...row,
            p_name_event: e.target.value,
            p_slug_event: e.target.value.replace(/[^\w\s]/gi, '').toLowerCase().replace(/ /g, '-')
          })
        }}
        maxLength={255}
      />
      <Input
        text="Slug"
        placeholder="Slug"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_slug_event}
        onChange={e => setRow({ ...row, p_slug_event: e.target.value })}
        maxLength={255}
      />
      <SwitchToggle
        id="event-enabled"
        textCheck="Desactivar"
        textUnChecked="Activar"
        classNameParent="col-12 mb-3"
        checked={row.p_enabled_event === 1}
        onChange={e => setRow({ ...row, p_enabled_event: e.target.checked ? 1 : 0 })}
      />
      <SwitchToggle
        id="event-show-ecommerce"
        textCheck="Desactivar Ecommerce"
        textUnChecked="Activar Ecommerce"
        classNameParent="col-12 mb-3"
        checked={row.p_show_ecommerce === 1}
        onChange={e => setRow({ ...row, p_show_ecommerce: e.target.checked ? 1 : 0 })}
      />
      <SelectCustom
        valueId={row.p_id_type_event}
        keyName="type_event"
        options={typeEvents}
        setRow={setRow}
        row={row}
        selectText="Tipo de evento"
      />
      <Input
        text="Fecha"
        type="date"
        placeholder="Fecha"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_date_event}
        onChange={e => setRow({ ...row, p_date_event: e.target.value })}
      />
      <Input
        text="Hora"
        type="time"
        placeholder="Hora"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_hour_event}
        onChange={e => setRow({ ...row, p_hour_event: e.target.value })}
        step="1"
      />
      <Input
        text="Ubicación"
        placeholder="Ubicación"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_location_event}
        onChange={e => setRow({ ...row, p_location_event: e.target.value })}
        maxLength={255}
      />
      <div className="col-12 mb-4">
        <small>Descripción</small>
        <ReactQuill theme="snow" value={content} onChange={setContent} modules={modules} />
      </div>
      <Input
        type="file"
        text="Imagen Zonas"
        classNameParent="col-12 mb-3"
        required={rowId === ''}
        invalid="El campo es obligatorio."
        onChange={e => {
          const files = e.target.files
          setRow({ ...row, p_image_event: files })
          setPreviewImage(files.length > 0 ? URL.createObjectURL(files[0]) : null)
        }}
        accept="image/*"
      />
      {(row.p_image_event_path || previewImage) && <div className='col-12 mb-3'>
        <small className='text-muted'>
          Vista Previa
        </small>
        <div>
          <img src={previewImage ? previewImage : (apiResource({
            url: row.p_image_event_path
          }))} alt={row.p_name_event} className="max-width-200 rounded" />
        </div>
      </div>}
      <Input
        type="file"
        text="Banner Pequeño"
        classNameParent="col-12 mb-3"
        required={rowId === ''}
        invalid="El campo es obligatorio."
        onChange={e => {
          const files = e.target.files
          setRow({ ...row, p_banner_small_event: files })
          setPreviewBannerSmall(files.length > 0 ? URL.createObjectURL(files[0]) : null)
        }}
        accept="image/*"
      />
      {(row.p_banner_small_event_path || previewBannerSmall) && <div className='col-12 mb-3'>
        <small className='text-muted'>
          Vista Previa
        </small>
        <div>
          <img src={previewBannerSmall ? previewBannerSmall : (apiResource({
            url: row.p_banner_small_event_path
          }))} alt={row.p_name_event} className="max-width-200 rounded" />
        </div>
      </div>}
      <Input
        type="file"
        text="Banner Grande (1200x620)"
        classNameParent="col-12 mb-3"
        required={rowId === ''}
        invalid="El campo es obligatorio."
        onChange={e => {
          const files = e.target.files
          setRow({ ...row, p_banner_large_event: files })
          setPreviewBannerLarge(files.length > 0 ? URL.createObjectURL(files[0]) : null)
        }}
        accept="image/*"
      />
      {(row.p_banner_large_event_path || previewBannerLarge) && <div className='col-12 mb-3'>
        <small className='text-muted'>
          Vista Previa
        </small>
        <div>
          <img src={previewBannerLarge ? previewBannerLarge : (apiResource({
            url: row.p_banner_large_event_path
          }))} alt={row.p_name_event} className="max-width-200 rounded" />
        </div>
      </div>}
      <Input
        type="file"
        text="PDF Fondo Boleto"
        classNameParent="col-12 mb-3"
        required={rowId === ''}
        invalid="El campo es obligatorio."
        onChange={e => {
          const files = e.target.files
          setRow({ ...row, p_pdf_background: files })
          setPreviewBg(files.length > 0 ? URL.createObjectURL(files[0]) : null)
        }}
        accept="image/*"
      />
      {(row.p_pdf_background_path || previewBg) && <div className='col-12 mb-3'>
        <small className='text-muted'>
          Vista Previa
        </small>
        <div>
          <img src={previewBg ? previewBg : (apiResource({
            url: row.p_pdf_background_path
          }))} alt={row.p_name_event} className="max-width-200 rounded" />
        </div>
      </div>}
    </FormCustom>
  </ReactPlaceholder>
}

EventForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  EventForm
};